import React, { useEffect, useRef, useState } from 'react';

/**
 * Video de fondo que no descarga nada hasta acercarse al viewport y que se
 * pausa al alejarse: un video que sigue corriendo fuera de vista sigue
 * decodificando, y con varios en la página el scroll se pone lento.
 */
export default function LazyVideo({ src, className = '', rootMargin = '400px', ...rest }) {
    const ref = useRef(null);
    const [active, setActive] = useState(false);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const el = ref.current;
        if (!el) return undefined;
        if (!('IntersectionObserver' in window)) {
            setActive(true);
            setVisible(true);
            return undefined;
        }
        const io = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) setActive(true);
            setVisible(entry.isIntersecting);
        }, { rootMargin });
        io.observe(el);
        return () => io.disconnect();
    }, [rootMargin]);

    // `autoPlay` no siempre arranca cuando el src llega después del montaje
    useEffect(() => {
        const video = ref.current;
        if (!active || !video) return;
        if (!visible) {
            video.pause();
            return;
        }
        video.muted = true;
        const p = video.play();
        if (p && typeof p.catch === 'function') p.catch(() => { });
    }, [active, visible]);

    return (
        <video
            ref={ref}
            src={active ? src : undefined}
            autoPlay
            muted
            loop
            playsInline
            preload="none"
            aria-hidden="true"
            className={className}
            {...rest}
        />
    );
}
